<template>
<div>
    <pt-sub-title title="生命里程碑"></pt-sub-title>
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table">
     <wt-table :list="tableData" :labels="tableLabels">
     </wt-table>
     </wt-paged-table>
</div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        mallUserId: this.id,
        pageableParam: {
          page: page,
          size: 10
        }
      }
      this.$store.dispatch('lifeMilestone', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取用户里程碑列表失败')
      })
    }
  },
  created () {
  }
}
</script>
